import { render, staticRenderFns } from "./CouponCenterPanel.vue?vue&type=template&id=545d74e0&scoped=true"
import script from "./CouponCenterPanel.vue?vue&type=script&lang=js"
export * from "./CouponCenterPanel.vue?vue&type=script&lang=js"
import style0 from "./CouponCenterPanel.vue?vue&type=style&index=0&id=545d74e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d74e0",
  null
  
)

export default component.exports